import * as Scrivito from "scrivito";
import I18n from "^/config/i18n";

const SignLanguageButton = ({ signLanguagePageLink }) => {
  if (!signLanguagePageLink) {
    return <div />;
  }
  return (
    <Scrivito.LinkTag
      to={signLanguagePageLink}
      title={I18n.t("Sign language button")}
      className="d-inline-block"
    >
      <i className="las la-sign-language nav-icon" />
    </Scrivito.LinkTag>
  );
};

export default Scrivito.connect(SignLanguageButton);
